module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators 3.225d6dfa.webp";